import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

import { _t } from "@/lib/i18n";
export const PasswordInput = ({ testId, className = "", ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input data-testid={testId} type={show ? "text" : "password"} className={`tc-input pr-11 ${className}`} {...props} />
      <button type="button" data-testid={`${testId}-toggle`} onClick={() => setShow((s) => !s)}
        aria-label={show ? _t("Nascondi password") : _t("Mostra password")} title={show ? _t("Nascondi password") : _t("Mostra password")}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/50 hover:text-white transition-colors">
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};
